export default __webpack_public_path__ + "static/media/qhacksCrown-black.73312688.svg";